function init(parent) {
  const input = parent.querySelector('.chat__input');

  const updateInputHeight = () => {
    input.style.height = 'auto';
    let height = input.scrollHeight ? input.scrollHeight : 28;
    height = height < 106 ? height : 106;
    input.style.height = `${height}px`;
  };

  input.addEventListener('input', updateInputHeight);
  updateInputHeight();
}

export function chat() {
  document.querySelectorAll('.chat').forEach((chat) => init(chat));
}
